// @ts-nocheck
import * as types from '../types';
import StaticDataService from '../../services/StaticDataService';
import GeneralService from '../../services/GeneralService';
import RiskMonitoringService from '../../services/RiskMonitoringService';
import { getSpecifierLabel } from '../../utils/render';

export const getStatuses = () => async dispatch => {
    const { info, items: statuses } = await StaticDataService.getStatuses();

    if (!info.success) {
        return;
    }

    dispatch(setStatuses(statuses));

    return statuses;
};

export const setStatuses = list => ({
    type: types.STATIC_STATUSES_CHANGED,
    payload: list,
});

export const getCities = () => async dispatch => {
    const { info, items: cityAndRegion } = await StaticDataService.getCities();

    if (!info.success) {
        return;
    }

    dispatch(setCityAndRegion(cityAndRegion));

    return cityAndRegion;
};

export const setCityAndRegion = list => ({
    type: types.STATIC_CITY_AND_REGION_CHANGED,
    payload: list,
});

export const setSelectedCity = id => ({
    type: types.SELECTED_CITY_CHANGED,
    payload: id,
});

export const getTicketSubStatuses = () => async dispatch => {
    const { info, items } = await GeneralService.getTicketSubStatuses();

    if (!info.success) return;

    dispatch(setTicketStatuses(items));

    return items;
};

export const setTicketStatuses = list => ({
    type: types.STATIC_TICKET_SUB_STATUSES_CHANGED,
    payload: list,
});

export const getCompetitionTypes = () => async dispatch => {
    const { info, items } = await GeneralService.getCompetitionTypes();

    if (!info.success) {
        return;
    }

    dispatch(setCompetitionTypes(items));

    return items;
};

export const setCompetitionTypes = list => ({
    type: types.STATIC_COMPETITION_TYPES_CHANGED,
    payload: list,
});

export const getSports = () => async dispatch => {
    const { info, items } = await GeneralService.getSports();

    if (!info.success) return;

    dispatch(setSports(items));
};

export const setSports = list => ({
    type: types.STATIC_SPORTS_CHANGED,
    payload: list,
});

export const getCategories = params => async dispatch => {
    const { info, items } = await GeneralService.getCategories(params);

    if (!info.success) return;

    dispatch(setCategories(items));

    return items;
};

export const setCategories = list => ({
    type: types.STATIC_CATEGORIES_CHANGED,
    payload: list,
});

export const getCategoriesAndMarkets = params => async dispatch => {
    const { info, item } = await GeneralService.getCategoriesAndMarkets(params);

    if (!info.success) return;

    const formattedMarkets = item.markets.map(market => ({ ...market, value: market.id }));

    dispatch(setCategories(item.categories));
    dispatch(setSportsMarkets(formattedMarkets));
};

export const getMarketsBySport = params => async dispatch => {
    const { info, item } = await GeneralService.getCategoriesAndMarkets(params);

    if (!info.success) return;

    const formattedMarkets = item.markets.map(market => ({ ...market, value: market.id }));

    dispatch(setSportsMarkets(formattedMarkets));

    return item;
};

export const getMarketsForStaticLabels = params => async dispatch => {
    const { info, items } = await GeneralService.getMarketsForStaticLabels(params);

    if (!info.success) return;

    const formattedMarkets = items.map(market => ({ ...market, value: market.id }));

    dispatch(setSportsMarkets(formattedMarkets));

    return formattedMarkets;
};

export const getOutcomesByMarket = params => async dispatch => {
    const { info, items } = await GeneralService.getOutcomesByMarket(params);

    if (!info.success) return;

    dispatch(
        setOutcomes(
            items.map(item => ({
                value: item.outcomeRefId,
                name: item.name,
            })),
        ),
    );

    return items;
};

export const setOutcomes = list => ({
    type: types.STATIC_OUTCOMES_CHANGED,
    payload: list,
});

export const getDynamicMarketsBySport = params => async dispatch => {
    const { info, items } = await GeneralService.getDynamicMarketsBySport(params);

    if (!info.success) return;

    const formattedMarkets = items.map(market => ({ ...market, value: market.id }));

    dispatch(setSportsMarkets(formattedMarkets));

    return items;
};

export const getAllLeaguesBySport = params => async dispatch => {
    const { info, items } = await GeneralService.getAllLeaguesBySport(params);

    if (!info.success) return;

    dispatch(setTournaments(items));

    return items;
};

export const getTournamentsBySportAndCategory = params => async dispatch => {
    const { info, items } = await GeneralService.getTournamentsBySportAndCategory(params);

    if (!info.success) return;

    dispatch(setTournaments(items));

    return items;
};

export const setSportsMarkets = list => ({
    type: types.STATIC_SPORTS_MARKETS_CHANGED,
    payload: list,
});

export const getTournaments = params => async dispatch => {
    const { info, items } = await GeneralService.getTournaments(params);

    if (!info.success) return;

    dispatch(setTournaments(items));
};

export const getActiveTournamentsAndEvents = params => async dispatch => {
    const { info, items } = await GeneralService.getActiveTournamentsAndEvents(params);

    if (!info.success) return;

    let tournaments = {};
    let events = {};

    items.forEach(tournament => {
        tournaments[tournament.leagueId] = {
            id: tournament.leagueId,
            name: tournament.leagueName,
        };

        tournament.events.forEach(event => {
            events[event.eventId] = {
                id: event.eventId,
                name: event.eventName,
                programCode: event.eventCode,
                leagueId: tournament.leagueId,
            };
        });
    });

    tournaments = Object.values(tournaments);
    events = Object.values(events);

    dispatch(setTournaments(tournaments));
    dispatch(setEvents(events));

    return { tournaments, events };
};

//TODO this is temporary,remove after bonus presentation

export const getActiveTournamentsAndEventsForBonus = params => async dispatch => {
    const { info, items } = await GeneralService.getActiveTournamentsAndEventsForBonus(params);

    if (!info.success) return;

    let tournaments = {};
    let events = {};

    items.forEach(tournament => {
        tournaments[tournament.leagueId] = {
            id: tournament.leagueId,
            name: tournament.leagueName,
        };

        tournament.events.forEach(event => {
            events[event.eventId] = {
                id: event.eventId,
                name: event.eventName,
                programCode: event.eventCode,
                leagueId: tournament.leagueId,
                leagueName: tournament.leagueName,
            };
        });
    });

    tournaments = Object.values(tournaments);
    events = Object.values(events);

    dispatch(setTournaments(tournaments));
    dispatch(setEvents(events));

    return { tournaments, events };
};

export const getUsedTournamentsAndEvents = params => async dispatch => {
    const { info, items } = await GeneralService.getUsedTournamentsAndEvents(params);

    if (!info.success) return;

    let tournaments = {};
    let events = {};

    items.forEach(tournament => {
        tournaments[tournament.leagueId] = {
            id: tournament.leagueId,
            name: tournament.leagueName,
            categoryName: tournament.categoryName,
        };

        tournament.events.forEach(event => {
            events[event.eventId] = {
                id: event.eventId,
                name: event.eventName,
                leagueId: tournament.leagueId,
                programCode: event.programCode,
            };
        });
    });

    tournaments = Object.values(tournaments).sort(
        (a, b) => a.categoryName.localeCompare(b.categoryName) || a.name.localeCompare(b.name),
    );
    events = Object.values(events).sort((a, b) => a.programCode.localeCompare(b.programCode));

    dispatch(setTournaments(tournaments));
    dispatch(setEvents(events));
};

export const setTournaments = list => ({
    type: types.STATIC_TOURNAMENTS_CHANGED,
    payload: list,
});

export const setEvents = list => ({
    type: types.STATIC_EVENTS_CHANGED,
    payload: list,
});

export const getAllEventMarkets = params => async dispatch => {
    const { info, items } = await GeneralService.getAllEventMarkets(params);

    if (!info.success) return;

    const formattedMarkets = items.map(item => ({ ...item, value: item.id }));

    dispatch(setMarkets(formattedMarkets));

    return formattedMarkets;
};

export const getUsedEventMarkets = (params, valuePropName) => async dispatch => {
    const { info, items } = await GeneralService.getUsedEventMarkets(params);

    if (!info.success) return;

    const formattedMarkets = items.map(item => ({ ...item, value: item[valuePropName] }));

    dispatch(setMarkets(formattedMarkets));
};

export const getSpecifiers = params => async dispatch => {
    const { info, items } = await RiskMonitoringService.getSpecifiers(params);

    if (!info.success) return;
    const formattedSpecifiers = items.map(item => ({
        ...item,
        value: item.specifierValue,
        label: item.specifierValue,
    }));
    dispatch(setMarketSpecifiers(formattedSpecifiers));
};

export const setMarkets = list => ({
    type: types.STATIC_MARKETS_CHANGED,
    payload: list,
});

export const getMarketSpecifiers = params => async dispatch => {
    const { info, items } = await GeneralService.getMarketSpecifiers(params);

    if (!info.success) return;

    const formattedSpecifiers = items.map(item => {
        const label = getSpecifierLabel(item.values);
        return {
            ...item,
            value: item.marketHash,
            label,
        };
    });

    dispatch(setMarketSpecifiers(formattedSpecifiers));
};

export const setMarketSpecifiers = list => ({
    type: types.STATIC_SPECIFIERS_CHANGED,
    payload: list,
});

export const getClientTypes = () => async dispatch => {
    const { info, items } = await StaticDataService.getClientTypes();

    if (!info.success) return;

    dispatch(setClientTypes(items));
};

export const setClientTypes = payload => ({
    type: types.CLIENT_TYPES_CHANGED,
    payload: payload,
});

export const getActivities = params => async dispatch => {
    const { info, items } = await StaticDataService.getActivities(params);

    if (!info.success) return;

    dispatch(setActivities(items));
};

export const setActivities = payload => ({
    type: types.STATIC_ACTIVITIES_CHANGED,
    payload: payload,
});

export const getBalanceActivities = params => async dispatch => {
    const { info, items } = await StaticDataService.getBalanceActivities(params);

    if (!info.success) return;

    dispatch(setBalanceActivities(items));
};

export const setBalanceActivities = payload => ({
    type: types.STATIC_BALANCE_ACTIVITIES_CHANGED,
    payload: payload,
});

export const getGroupByOptions = params => async dispatch => {
    const { info, item } = await StaticDataService.getGroupByOptions(params);

    if (!info.success) return;

    dispatch(setGroupByOptions(item));
};

export const setGroupByOptions = payload => ({
    type: types.STATIC_GROUPBY_OPTIONS_CHANGED,
    payload: payload,
});

export const clearGroupByOptions = () => ({
    type: types.STATIC_GROUPBY_OPTIONS_CLEARED,
});

export const getActiveEventsByTournamentId = params => async dispatch => {
    const { info, item } = await GeneralService.getActiveEventsByTournamentId(params);

    if (!info.success) return;

    const events = item.events.map(event => {
        return {
            ...event,
            id: event.eventId,
            leagueId: item.leagueId,
            name: event.eventName,
            programCode: event.eventCode,
            scheduledTime: event.scheduledTime,
        };
    });

    dispatch(setActiveEvents(events));

    return item;
};

export const getActiveTournamentsByCategory = params => async dispatch => {
    const { info, items } = await GeneralService.getActiveTournamentsByCategory(params);

    if (!info.success) return;

    dispatch(setTournaments(items));
};

export const getEventsByKeyword = keyword => async dispatch => {
    dispatch(setEventSearchResults([]));

    const { info, items } = await GeneralService.getEventsByKeyword({ eventInfo: keyword, isLive: false });

    if (!info.success) return;

    dispatch(setEventSearchResults(items));
};

export const getMarketsByEvent = params => async dispatch => {
    const { info, items } = await GeneralService.getMarketsByEvent(params);

    if (!info.success) return;

    const formattedMarkets = items.map(item => ({ ...item, value: item.marketHash, name: item.marketName }));

    dispatch(setMarkets(formattedMarkets));

    return items;
};

export const setEventSearchResults = list => ({
    type: types.STATIC_EVENT_SEARCH_RESULTS_CHANGED,
    payload: list,
});

export const getEventDetailsById = id => async dispatch => {
    const { info, item } = await GeneralService.getEventDetails({ eventId: id });

    if (!info.success) return;

    const { sportId, categoryId, leagueId, eventId } = item;

    dispatch(getCategories({ sportId }));
    dispatch(getActiveTournamentsByCategory({ categoryId, isLive: false, isActive: true }));
    dispatch(getActiveEventsByTournamentId({ tournamentId: leagueId, isLive: false, isActive: true }));
    dispatch(getMarketsByEvent({ eventId, sportId, isActive: true }));

    return item;
};

export const setActiveEvents = list => ({
    type: types.STATIC_ACTIVE_EVENTS_CHANGED,
    payload: list,
});

export const getActionTypes = () => async dispatch => {
    const { info, items } = await StaticDataService.getActionTypes();

    if (!info.success) return;

    dispatch(setActionTypes(items));
};

export const setActionTypes = payload => ({
    type: types.STATIC_ACTION_TYPES_CHANGED,
    payload: payload,
});

export const getPaymentMethods = () => async dispatch => {
    const { info, items } = await StaticDataService.getPaymentMethods();

    if (!info.success) return;

    dispatch(setPaymentMethods(items));
};

export const setPaymentMethods = payload => ({
    type: types.STATIC_PAYMENT_METHODS_CHANGED,
    payload: payload,
});

export const getPaymentProviders = () => async dispatch => {
    const { info, items } = await StaticDataService.getPaymentProviders();

    if (!info.success) return;

    dispatch(setPaymentProviders(items));
};

export const setPaymentProviders = payload => ({
    type: types.STATIC_PAYMENT_PROVIDERS_CHANGED,
    payload: payload,
});

export const getSources = () => async dispatch => {
    const { info, items } = await StaticDataService.getSources();

    if (!info.success) return;

    dispatch(setSources(items));
};

export const setSources = payload => ({
    type: types.STATIC_SOURCES_CHANGED,
    payload: payload,
});

export const getConditionTypes = () => async dispatch => {
    const { info, items } = await StaticDataService.getConditionTypes();

    if (!info.success) return;

    dispatch(setConditionTypes(items));
};

export const setConditionTypes = payload => ({
    type: types.STATIC_CONDITION_TYPES_CHANGED,
    payload: payload,
});

export const getOperationTypes = () => async dispatch => {
    const { info, items } = await StaticDataService.getOperationTypes();

    if (!info.success) return;

    dispatch(setOperationTypes(items));
};

export const setOperationTypes = payload => ({
    type: types.STATIC_OPERATION_TYPES_CHANGED,
    payload: payload,
});

export const getWithdrawRuleConditions = () => async dispatch => {
    const { info, items } = await StaticDataService.getWithdrawRuleConditions();

    if (!info.success) return;

    dispatch(setWithdrawRuleConditions(items));
};

export const setWithdrawRuleConditions = payload => ({
    type: types.STATIC_WITHDRAWAL_RULE_CONDITIONS_CHANGED,
    payload: payload,
});

export const getPlayerMassUpdateActionTypes = () => async dispatch => {
    const { info, items } = await StaticDataService.getPlayerMassUpdateActionTypes();

    if (!info.success) return;

    dispatch(setPlayerMassUpdateActionTypes(items));
};

export const setPlayerMassUpdateActionTypes = payload => ({
    type: types.STATIC_PLAYER_MASS_UPDATE_ACTION_TYPES_CHANGED,
    payload: payload,
});

export const getUserStatus = params => async dispatch => {
    const { info, items } = await StaticDataService.getUserStatus(params);

    if (!info.success) return;

    dispatch(setUserStatus(items));
};

export const setUserStatus = payload => ({
    type: types.STATIC_USER_STATUS_CHANGED,
    payload: payload,
});

export const getFreezeTypes = params => async dispatch => {
    const { info, items } = await StaticDataService.getFreezeType(params);

    if (!info.success) return;

    dispatch(setFreezeTypes(items));
};

export const setFreezeTypes = payload => ({
    type: types.STATIC_FREEZE_TYPE_CHANGED,
    payload: payload,
});

export const getWalletTypes = params => async dispatch => {
    const { info, items } = await StaticDataService.getWalletType(params);

    if (!info.success) return;

    dispatch(setWalletTypes(items));
};

export const setWalletTypes = payload => ({
    type: types.STATIC_WALLET_TYPE_CHANGED,
    payload: payload,
});

export const getChannelTypes = () => async dispatch => {
    const { info, items } = await GeneralService.getChannelTypes();

    if (!info.success) return;

    dispatch(setChannelTypes(items));

    return items;
};

export const setChannelTypes = payload => ({
    type: types.STATIC_CHANNEL_RECEIVED,
    payload,
});

export const getPlayerSegmentFilterTypes = () => async dispatch => {
    const { info, items } = await StaticDataService.getPlayerSegmentFilterTypes();

    if (!info.success) return;

    dispatch(setPlayerSegmentFilterTypes(items));
};

export const setPlayerSegmentFilterTypes = payload => ({
    type: types.STATIC_PLAYER_SEGMENT_FILTER_TYPES_CHANGED,
    payload: payload,
});

export const getArchiveStatuses = () => async dispatch => {
    const { info, items } = await StaticDataService.getArchiveStatuses();

    if (!info.success) return;

    dispatch(setArchiveStatuses(items));
};

export const setArchiveStatuses = payload => ({
    type: types.STATIC_ARCHIVE_STATUSES_CHANGED,
    payload: payload,
});

export const getCommunicationCategories = () => async dispatch => {
    const { info, items } = await StaticDataService.getCommunicationCategories();

    if (!info.success) return;

    dispatch(setCommunicationCategories(items));
};

export const setCommunicationCategories = payload => ({
    type: types.STATIC_COMMUNICATION_CATEGORIES_CHANGED,
    payload: payload,
});

export const getCommunicationChannels = () => async dispatch => {
    const { info, items } = await StaticDataService.getCommunicationChannels();

    if (!info.success) return;

    dispatch(setCommunicationChannels(items));
};

export const setCommunicationChannels = payload => ({
    type: types.STATIC_COMMUNICATION_CHANNELS_CHANGED,
    payload: payload,
});

export const getCommunicationDirections = () => async dispatch => {
    const { info, items } = await StaticDataService.getCommunicationDirections();

    if (!info.success) return;

    dispatch(setCommunicationDirections(items));
};

export const setCommunicationDirections = payload => ({
    type: types.STATIC_COMMUNICATION_DIRECTIONS_CHANGED,
    payload: payload,
});

export const getMessageStatuses = () => async dispatch => {
    const { info, items } = await StaticDataService.getMessageStatuses();

    if (!info.success) return;

    dispatch(setMessageStatuses(items));
};

export const setMessageStatuses = payload => ({
    type: types.STATIC_MESSAGE_STATUSES_CHANGED,
    payload: payload,
});

export const getNoteCategories = () => async dispatch => {
    const { info, items } = await StaticDataService.getNoteCategories();

    if (!info.success) return;

    dispatch(setNoteCategories(items));
};

export const setNoteCategories = payload => ({
    type: types.STATIC_NOTE_CATEGORIES_CHANGED,
    payload: payload,
});

export const getLogTypes = () => async dispatch => {
    const { info, items } = await StaticDataService.getRequestMethods();

    if (!info.success) return;

    dispatch(setLogTypes(items));
};

export const setLogTypes = payload => ({
    type: types.STATIC_LOG_TYPES_CHANGED,
    payload,
});

export const getTicketOperationTypes = () => async dispatch => {
    const { info, items } = await StaticDataService.getTicketOperationTypes();

    if (!info.success) return;

    dispatch(setTicketOperationTypes(items));
};

export const setTicketOperationTypes = payload => ({
    type: types.STATIC_TICKET_OPERATION_TYPES_CHANGED,
    payload,
});

export const getTicketOperationStatuses = () => async dispatch => {
    const { info, items } = await StaticDataService.getTicketOperationStatuses();

    if (!info.success) return;

    dispatch(setTicketOperationStatuses(items));
};

export const setTicketOperationStatuses = payload => ({
    type: types.STATIC_TICKET_OPERATION_STATUSES_CHANGED,
    payload,
});
